// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-7"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 5H16.5V7.11339C16.5 7.36216 16.4073 7.60199 16.2399 7.78607L11.7601 12.7139C11.5927 12.898 11.5 13.1378 11.5 13.3866V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers7Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-7',
    ref,
    icon: element,
  },
));

Numbers7Icon.displayName = 'Numbers7Icon';

export default Numbers7Icon;
